import { defineMessages } from 'react-intl';

export const messages: {
	remove_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	remove_button_label: {
		id: 'search_dialog.results.remove_button_label',
		defaultMessage: 'Remove this.',
		description: 'Label of the button that has remove function and appearance.',
	},
});
